module.exports = __webpack_public_path__ + "img/ics_f_thumb-bad-disabled.006893ee.svg";